export const ANSWER_COUNT = 10;